import React from "react";
import Link from "next/link";
import { FunctionComponent } from "react";

const Hyperlink: FunctionComponent<
  {
    href: string;
  } & React.JSX.IntrinsicElements["a"]
> = ({ href, children, ...props }) => {
  if (href.startsWith("http")) {
    // External link
    return (
      <a target="_blank" rel="noreferrer" href={href} {...props}>
        {children}
      </a>
    );
  } else {
    return (
      <Link href={href} passHref {...props}>
        {children}
      </Link>
    );
  }
};

export default Hyperlink;
